// @mui
import { Box, Typography, Stack } from '@mui/material';
// assets
import { UploadIllustration } from '../../assets';
// components
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

export default function BlockContentLayout() {
  const { translate } = useLocales();
  return (
    <Stack
      spacing={2}
      alignItems="center"
      justifyContent="center"
      direction={{ xs: 'column', md: 'column' }}
      sx={{ width: 1, textAlign: { xs: 'center', md: 'left' }, height: '100%' }}
    >
      <UploadIllustration sx={{ width: 220 }} />

      <Box sx={{ p: 3, height: '100%' }}>
        <Typography gutterBottom variant="h5">
          {translate('upload.drop_or_select')}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          {translate('upload.drop_img_or_click')}&nbsp;
          <Typography variant="body2" component="span" sx={{ color: 'primary.main', textDecoration: 'underline' }}>
            {translate('upload.browse')}
          </Typography>
          &nbsp;{translate('upload.thorough_your_machine')}
        </Typography>
      </Box>
    </Stack>
  );
}
